import axios from "axios";
import React, { useState } from "react";
import { useQuery } from "react-query";
import Achievements from "../../../components/sections/Achievements";
import Announcement from "../../../components/sections/Announcement";
import EducationList from "../../../components/sections/EducationList";
import FeedSection from "../../../components/sections/FeedSection";
import MainProfile from "../../../components/sections/MainProfile";
import SchoolAnnouncementFeed from "../../../components/sections/SchoolAnnouncementFeed";
import { serverUrl } from "../../../nestserver";

function Profile() {
  const [activeTab, setActiveTab] = useState("school-post");

  async function getAnnouncement() {
    const data = await axios({
      method: "get",
      url: serverUrl + "/announcement",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return data.data;
  }

  const announcement = useQuery("announcement", getAnnouncement);
  return (
    <div className="h-full p-10 ">
      <MainProfile />
      <div className="pt-10">
        <EducationList />
      </div>
      <div className="pt-10">
        <Achievements />
      </div>
      <Announcement />
      <div className="py-10">
        <div className="bg-white w-full rounded-2xl bg-opacity-40 px-4 pb-4">
          <div className="flex items-center gap-8 p-4 py-6">
            {[
              { key: "school-post", label: "School Post" },
              { key: "class-update", label: "Class Update" },
            ].map((tab) => (
              <div
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className="text-2xl font-semibold cursor-pointer pb-1"
                style={{
                  color: activeTab === tab.key ? "#E46E31" : "#9ca3af",
                  borderBottom:
                    activeTab === tab.key
                      ? "3px solid #E46E31"
                      : "3px solid transparent",
                }}
              >
                {tab.label}
              </div>
            ))}
          </div>
          {activeTab === "school-post" ? (
            <div className="space-y-5">
              {announcement?.isSuccess &&
                announcement?.data?.map((item) => {
                  return (
                    <FeedSection
                      enableDelete={true}
                      key={item?._id}
                      data={item}
                    />
                  );
                })}
            </div>
          ) : (
            <SchoolAnnouncementFeed />
          )}
        </div>
      </div>
    </div>
  );
}

export default Profile;
